import {
  AllocationWarning,
  CheckAllocationWarningsRequest,
  ExistingTaskCheckRequest,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function isExistingTaskRequest(
  request: CheckAllocationWarningsRequest,
): request is ExistingTaskCheckRequest {
  return "taskUuid" in request;
}

function checkAllocationWarnings(httpClient: HttpClient) {
  return (request: CheckAllocationWarningsRequest) =>
    new Promise<AllocationWarning[]>((resolve, reject) =>
      httpClient
        .sendHttpRequest<AllocationWarning[]>({
          endpoint: `/allocations/check-warnings`,
          method: HttpMethods.POST,
          data: isExistingTaskRequest(request)
            ? {
                taskUuid: request.taskUuid,
                allocations: request.allocations,
              }
            : {
                taskDraft: request.taskDraft,
              },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { checkAllocationWarnings };
